import React, { FC } from 'react';
import cls from 'classnames';

import { BadgeProps, BadgeVariant } from './Badge.types';
import { getClassNames, getRootClassListFromProps } from '../../../utilities/classNames';
export const classNames = getClassNames('sds-badge');

const Badge: FC<BadgeProps> & { Variant: typeof BadgeVariant } = (props) => {
	const { variant, children, className } = props;

	return <div className={cls(getRootClassListFromProps(classNames, props), variant, className)}>{children}</div>;
};

Badge.displayName = 'Badge';
Badge.Variant = BadgeVariant;

export default Badge;
